import { format } from '@/helpers/datetime'
import moment from 'moment'
import formattedValue from '@/helpers/formattedValue'

export default {
  props: {
    loading: {
      type: Boolean
    },
    reportData: {
      type: Object
    },
    printable: {
      type: Boolean,
      default: () => false
    },
    autoExport: {
      type: Boolean,
      default: () => true
    },
    pageWidth: {
      type: Number
    }
  },
  data() {
    return {
      tableDataSummaryLocation: [],
      tableDataHistory: {},
      tableDataHistoryColumn: [
        {
          type: 'date',
          text: 'Date',
          value: 'date'
        }
      ],
      ChartSummaryData: [],
      reportHeader: [
        {
          name: 'Customer',
          content: '-'
        },
        {
          name: 'Period',
          content: 'Daily'
        },
        {
          name: 'Time Period',
          content: 'September 12, 2020 11:28 AM -  Sep 30, 2020 11:28 AM'
        },
        {
          name: 'Report Date',
          content: format(new Date(), 'DD MMMM YYYY')
        }
      ],
      listFormulaData: [],
      reportPeriod: [],
      chartImage: [],
      options: {
        allowToAdd: false,
        allowToRefetch: true,
        allowExporting: true
      },
      summaryOptions: {
        allowToAdd: false,
        allowToRefetch: false,
        allowExporting: false
      },
      dateOptions: {
        daily: 'Daily',
        monthly: 'Monthly',
        yearly: 'Yearly'
      },
      customerLogo: '',
      currentPDFSource: {}
    }
  },
  async mounted() {
    // set period
    formattedValue.datePeriod(this.reportData.form.dataForm)

    if (
      this.reportData.form.reportType == 'Power by Customer' ||
      this.reportData.form.reportType == 'Power by Location'
    ) {
      let additionalData = [
        {
          name: 'Total Average Power',
          content: ''
        },
        {
          name: 'Total Contracted Power',
          content: ''
        }
      ]
      this.reportHeader.push(...additionalData)
      // set peak power & contracted power
      // let peakPower = this.reportHeader.find(
      //   (data) => data.name == 'Total Peak'
      // )
      // let minimumPower = this.reportHeader.find(
      //   (data) => data.name == 'Total Minimum'
      // )
      let contractedPower = this.reportHeader.find(
        (data) => data.name == 'Total Contracted Power'
      )
      let average = this.reportHeader.find(
        (data) => data.name == 'Total Average Power'
      )
      // peakPower.content = this.reportData.report.TotalPeak
      // minimumPower.content = this.reportData.report.TotalMinimum
      contractedPower.content = this.reportData.report.TotalContractedPower
      average.content = this.reportData.report.TotalAverage
    }

    if (this.reportData.form.reportType == 'Power by Location') {
      let customer = this.reportHeader.find((data) => data.name == 'Customer')
      customer.name = 'Location'
      customer.content = this.reportData.report.LocationList
    }

    if (this.reportData.form.reportType == 'Power by Customer') {
      let customer = this.reportHeader.find((data) => data.name == 'Customer')
      customer.content = this.reportData.report.CompanyList
    }

    if (this.reportData.report.ReportType == 'Compare Power by Location') {
      let customer = this.reportHeader.find((data) => data.name == 'Location')
      customer.content = `${this.reportData.report.ReportLocation1.LocationList}, ${this.reportData.report.ReportLocation2.LocationList}`
    }
    // period header
    var periodHeader = this.reportHeader.find((x) => x.name == 'Period')
    periodHeader.content = this.dateOptions[this.reportData.form.dataForm]

    // time period header
    var timeHeader = this.reportHeader.find((x) => x.name == 'Time Period')
    var startDate = formattedValue.readableDate(this.reportData.form.startDate)
    var endDate = formattedValue.readableDate(this.reportData.form.endDate)
    timeHeader.content = `${startDate} - ${endDate}`

    // set reportPeriod
    this.reportPeriod = this.getDates(
      new Date(this.reportData.form.startDate),
      new Date(this.reportData.form.endDate)
    )

    if (this.reportData.form.reportType === 'Power Billing') {
      const custHeaderIndex = this.reportHeader.findIndex(
        (x) => x.name === 'Customer'
      )
      this.reportHeader.splice(custHeaderIndex, 1)
    } else {
      // await this.getCustomerDetail()
      await this.getCustomerLogo()
    }
    await this.setAsPrintableReport()
    // await this.getFormulaData()

    if (this.autoExport) {
      this.$emit('generateReportNow', true)
    }
  },
  methods: {
    getChartData(formulaGroup) {
      return this.reportData.report.filter(
        (x) =>
          x.FormulaData.VarLabel === formulaGroup ||
          x.FormulaData.SubDeviceName === formulaGroup
      )
    },
    getUnit(formulaGroup) {
      var data = this.reportData.report.find(
        (x) =>
          x.FormulaData.VarLabel === formulaGroup ||
          x.FormulaData.SubDeviceName === formulaGroup
      )

      return data ? data.Unit : ''
    },
    getDates(startDate, endDate) {
      if (
        this.reportData.form.dataForm === 'monthly' ||
        this.reportData.form.dataForm === 'yearly'
      ) {
        endDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0)
      }

      let dates = []
      //to avoid modifying the original date
      const theDate = startDate
      while (theDate <= endDate) {
        dates = [...dates, new Date(theDate)]
        theDate.setDate(theDate.getDate() + 1)
      }
      return dates
    },
    groupByTimePeriod(data) {
      let res = {}

      let fn = (year, month, o = res, array = data) => {
        o[year][month] = {
          [month]: array.filter(
            ({ date: d }) => `${year}-${month}` === d.slice(0, 7)
          )
        }
      }

      for (let { date } of data) {
        let [year, month] = date.match(/\d+/g)
        if (!res[year]) res[year] = {}
        fn(year, month)
      }

      return res
    },
    groupByKey(array, key) {
      return array.reduce((hash, obj) => {
        if (obj[key] === undefined) return hash
        return Object.assign(hash, {
          [obj[key]]: (hash[obj[key]] || []).concat(obj)
        })
      }, {})
    },
    grouppeddDateByPeriod(stringDate) {
      if (this.reportData.form.dataForm === 'monthly') {
        return moment(stringDate, 'YYYY').format()
      } else if (this.reportData.form.dataForm === 'yearly') {
        return moment(stringDate, 'YYYY').format()
      } else {
        return moment(stringDate, 'MMMM-YYYY').format()
      }
    },
    formattedDate(stringDate) {
      return formattedValue.date(stringDate)
    },
    formattedDateTime(stringDate) {
      return formattedValue.datetime(stringDate)
    },
    readableFormattedDate(stringDate) {
      return formattedValue.readableDate(stringDate)
    },
    formattedValue(number, unit = '', decimal = 2) {
      if (unit === 'MYR') {
        return formattedValue.content(number, unit, decimal)
      } else {
        // force unit to empty
        return formattedValue.content(number, '', decimal)
      }
    },
    dateColumnLabel() {
      if (this.reportData.form.dataForm === 'monthly') {
        return 'Month'
      } else if (this.reportData.form.dataForm === 'yearly') {
        return 'Year'
      } else {
        return 'Date'
      }
    },
    setAsPrintableReport() {
      this.options = {
        allowToAdd: false,
        allowToRefetch: false,
        allowExporting: true
      }
    },
    setLoadingState(val) {
      this.$emit('contentLoading', val)
    },
    setDownloadPdf(val) {
      this.$emit('downloadPdf', val)
    },
    pdfSource(val) {
      this.currentPDFSource = val
      this.$emit('pdfSource', val)
    },
    setDownloadExcel(val) {
      this.$emit('downloadExcel', val)
    },
    setPrintReport(val) {
      this.$emit('printReport', val)
    },
    isGrouppingSumReport() {
      return (
        this.reportData.form.reportType == 'Energy Cost' ||
        this.reportData.form.reportType == 'Energy Cost Rack' ||
        this.reportData.form.reportType == 'Total PDU Energy'
      )
    },
    isDcoReport() {
      return this.reportData.form.reportType == 'DCO Data'
    },
    isAlarmReport() {
      return this.reportData.form.reportType == 'Alarm Report'
    },
    historicalData() {
      var _this = this
      // get asset list
      this.assets = [
        ...new Set(this.reportData.report.map((x) => x.FormulaData.GroupName))
      ]
      this.grouppedAssets = [
        ...new Set(this.reportData.report.map((x) => x.FormulaData.VarLabel))
      ]

      var tableDataHistory = {}
      for (var group of this.grouppedAssets) {
        // get report data
        var reportData = this.reportData.report.find(
          (x) => x.FormulaData.VarLabel === group
        )

        // get report historical
        tableDataHistory[group] = reportData.HistoricalValue.map(function (x) {
          var data = {
            date: formattedValue.date(x.Timestamp),
            formulaGroup: group,
            unit: x.Unit
          }

          for (var asset of _this.assets) {
            var findAsset = _this.reportData.report.find(
              (y) =>
                y.FormulaData.GroupName === asset &&
                y.FormulaData.VarLabel === group
            )

            // default historical assset value
            data[asset] = 0

            if (findAsset) {
              var assetHistoryValue = findAsset.HistoricalValue.find(
                (y) => formattedValue.date(y.Timestamp) === data.date
              )
              data[asset] = formattedValue.content(assetHistoryValue.DecimalVal)
            }
          }

          return data
        })
      }

      this.tableDataHistory = tableDataHistory
    },
    setChartBaseSource(value, group) {
      if (value) {
        var existingChartImage = this.chartImage.find((x) => x.name === group)
        if (existingChartImage) {
          existingChartImage.source = value
        } else {
          this.chartImage.push({
            name: group,
            source: value
          })
        }
      }
    },
    splitArray(arr, len) {
      var chunks = []
      var i = 0
      var n = arr.length

      while (i < n) {
        chunks.push(arr.slice(i, (i += len)))
      }

      return chunks
    },

    async getCustomerDetail() {
      try {
        this.setLoadingState(true)
        const res = await this.$axios.get(
          this.$appInfo.api.customer.getListCustomerWithData
        )

        // customer header
        var customerHeader = this.reportHeader.find((x) => x.name == 'Customer')
        customerHeader.content = res.data.find(
          (x) => x.DcoId === this.reportData.form.customer
        ).Company

        this.setLoadingState(false)
      } catch (e) {
        this.setLoadingState(false)
        console.log(e)
      }
    },
    async getFormulaData() {
      try {
        this.setLoadingState(true)

        // get all GroupName data from formula source
        const res = await this.$axios.post(
          this.$appInfo.api.formula.getByListVarName,
          {
            ListFormula: this.reportData.form.ListFormula
          }
        )

        // set ListFormulaData
        this.listFormulaData = res.data

        this.setLoadingState(false)
      } catch (e) {
        this.setLoadingState(false)
        console.log(e)
      }
    },
    async getCustomerLogo() {
      try {
        if (!this.reportData.form.customer) {
          return
        }

        const res = await this.$axios.get(
          this.$appInfo.api.customer.getMiniLogohotoBase64 +
            `?customer_name=` +
            this.reportData.form.customer
        )
        this.customerLogo = res.data
      } catch (e) {
        console.log('failed to fetch logo', e)
      }
    },
    getGeneratedFileName() {
      const periodType = this.reportData.form.dataForm

      const formatDate = (date) => {
        if (periodType === 'daily') return moment(date).format('DD MMM YYYY')
        else if (periodType === 'monthly')
          return moment(date).format('MMM YYYY')
        return moment(date).format('YYYY')
      }

      const uppercaseFirstLetter = (text) => {
        return text.charAt(0).toUpperCase() + text.slice(1)
      }

      if (this.reportData.form.reportLocation.length > 0) {
        let fileName = `${this.reportData.report.ReportType} - ${formatDate(
          this.reportData.form.startDate
        )} to  ${formatDate(
          this.reportData.form.endDate
        )} - ${new Date().getTime()}.pdf`
        return fileName
      } else {
        let fileName = this.reportData.form.reportType
        fileName += ` - ${uppercaseFirstLetter(
          this.reportData.form.dataForm
        )} - `
        fileName += formatDate(this.reportData.form.startDate) + ' to '
        fileName += formatDate(this.reportData.form.endDate) + ' - '
        fileName += new Date().getTime()
        fileName += '.pdf'

        return fileName
      }
    }
  },
  computed: {
    allowConfigureWidget() {
      return this.$store.state.auth.isAdmin
    },
    isCustomer() {
      return this.$store.state.auth.isCustomer
    },
    user() {
      return this.$store.state.auth.userData
    }
  },
  watch: {
    customerName: {
      handler(val) {
        if (val) {
          this.loadData()
        }
      }
    },
    'form.dataForm': {
      handler(val) {
        if (val) {
          this.form.startDate = ''
          this.form.endDate = ''
        }
      }
    },
    chartImage: {
      handler(val) {
        if (val && typeof this.preparePdf == 'function') {
          this.preparePdf()
        }
      }
    },
    reportHeader: {
      deep: true,
      handler(val) {
        if (val && typeof this.preparePdf == 'function') {
          this.preparePdf()
        }
      }
    },
    customerLogo: {
      deep: true,
      handler(val) {
        if (val && typeof this.preparePdf == 'function') {
          this.preparePdf()
        }
      }
    }
  }
}
